import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Text, VStack } from '@chakra-ui/react';
import { Page } from '../types';

const ForbiddenPage: Page = () => {
  return (
    <VStack
      w="full"
      h="100vh"
      justify="center"
      align="center"
      spacing={0}
      gap={6}
    >
      <Text as="h1" textStyle="h1">
        403
      </Text>
      <Text as="h2" textStyle="h2">
        This Page Is Forbidden
      </Text>
      <Button colorScheme="tomato" as={Link} to={'/'} className={'promoted'}>
        Go Back To Safety
      </Button>
    </VStack>
  );
};

ForbiddenPage.getRoute = () => '/forbidden/';

export default ForbiddenPage;
